import { render, staticRenderFns } from "./AdminAssets.vue?vue&type=template&id=b3ce8af2"
import script from "./AdminAssets.vue?vue&type=script&lang=js"
export * from "./AdminAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports